<template>
  <!-- Last Ditch Cancellation Confirmation Dialog -->
  <v-dialog
    v-model="localValue"
    width="500"
  >
    <v-card>
      <v-card-title>
        Cancel HawkSoft Text Messaging?
      </v-card-title>

      <v-card-text>

        <div class="mb-2">This action cannot be undone.</div>
        <div class="my-2">Once your agency has cancelled HawkSoft Text Messaging, the phone number will be released and all texting data HawkSoft has stored will be deleted.</div>
        <div class="my-2">You will not be able to get your number or any data back after this step.</div>

        <div v-if="oldFileWarning" class="mt-3">
          <div class="red--text font-weight-bold">Attention:</div>
          <div class="ml-2">The last &quot;<span class="font-italic">Text Message History</span>&quot; file requested was generated over an hour ago. Text message and attachment data received since this file was requested will be permanently lost. If you would like to keep this data, please go back and request/download a new &quot;<span class="font-italic">Text Message History</span>&quot; file.</div>
          <v-checkbox v-model="confirmDiscard" class="my-way" label="I acknowledge that text messages and attachments received by my agency since requesting &quot;Text Message History and Attachments&quot; will be permanently discarded, with no possibility of recovery." />
        </div>

      </v-card-text>

      <v-card-actions>
        <v-row dense>

          <v-col cols="auto">
            <v-btn
              color="primary"
              @click="localValue = false"
            >
              Cancel
            </v-btn>
          </v-col>

          <v-spacer />

          <v-col cols="auto">
            <v-btn
              color="error"
              :disabled="oldFileWarning && !confirmDiscard"
              @click="$emit('confirmed')"
            >
              Confirm Cancellation
            </v-btn>
          </v-col>

        </v-row>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<style lang="sass">
// @import '~vuetify/src/styles/main.sass'

.my-way .v-label
  font-size: .80rem
</style>

<script>
export default {
  name: 'DialogConfirmCancel',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    oldFileWarning: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    confirmDiscard: false
  }),
  computed: {
    localValue: {
      get () { return this.value; },
      set (val) { this.$emit('input', val); }
    }
  }
};
</script>
